module.exports = __webpack_public_path__ + "c1ad932725fd0c46e8d05351cbef1139.png";